import Button from "../base/Button";

const renderIcon = (color) => (
    <svg
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>add</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id="Symbols---Zep"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="LS-Menu"
                transform="translate(-40.000000, -14.000000)"
                fill={color}
                fillRule="nonzero"
            >
                <g id="add">
                    <g transform="translate(40.000000, 14.000000)">
                        <path
                            d="M31.2727273,15.2727273 L16.7272727,15.2727273 L16.7272727,0.727272727 C16.7272727,0.325818182 16.4021818,0 16,0 C15.5978182,0 15.2727273,0.325818182 15.2727273,0.727272727 L15.2727273,15.2727273 L0.727272727,15.2727273 C0.325090909,15.2727273 0,15.5985455 0,16 C0,16.4021818 0.325090909,16.7272727 0.727272727,16.7272727 L15.2727273,16.7272727 L15.2727273,31.2727273 C15.2727273,31.6749091 15.5978182,32 16,32 C16.4021818,32 16.7272727,31.6749091 16.7272727,31.2727273 L16.7272727,16.7272727 L31.2727273,16.7272727 C31.6749091,16.7272727 32,16.4021818 32,16 C32,15.5985455 31.6749091,15.2727273 31.2727273,15.2727273 Z"
                            id="Shape"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

/**
 * Toolbar button for adding a new light to the map.
 *
 * @param props - The base toolbar button props.
 * @returns The rendered add button.
 */
const AddButton = (props) => <Button {...props} renderIcon={renderIcon} />;

export default AddButton;
